import React from 'react';

import { useMediaConfig } from 'bdvp-common/src/hooks/config';
import { useAdobeTarget } from 'bdvp-common/src/hooks/store';

import {
    BaseSubnav,
    FilterSearchSubnav,
    FreeTextSearchSubnav,
} from '../components/Subnav';

const Subnav = () => {

    const { adobeTarget: adobeTargetConfig = {} } = useMediaConfig();
    const {
        loading,
        payload: isFreeTextSearchEnabled = false,
        enabled,
    } = useAdobeTarget(adobeTargetConfig, 'freeTextSearch');

    if(enabled && loading) {

        return (
            <BaseSubnav />
        );

    }

    return isFreeTextSearchEnabled ? <FreeTextSearchSubnav /> : <FilterSearchSubnav />;

};

export default Subnav;
